import { render, staticRenderFns } from "./quote-scope.vue?vue&type=template&id=5787a0fa&"
import script from "./quote-scope.vue?vue&type=script&lang=js&"
export * from "./quote-scope.vue?vue&type=script&lang=js&"
import style0 from "./quote-scope.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports